import { call, put, takeEvery } from 'redux-saga/effects';
import { fetchOrgInfo } from '@/containers/SpockViewPage/api';
import { upsertOrgs } from '@/common/slice/orgList';

export const FETCH_ORG_REQUEST = 'FETCH_ORG_REQUEST';
export const fetchOrgRequest = (orgIds) => ({ type: FETCH_ORG_REQUEST, payload: orgIds });

export function* watchFetchOrgRequest() {
  yield takeEvery(FETCH_ORG_REQUEST, function* ({ payload }) {
    yield* getOrgs(Array.isArray(payload) ? payload : [payload]);
  });
}

export function* getOrgs(orgIds) {
  const ids = Array.isArray(orgIds) ? orgIds.filter((id) => id != null) : [];
  if (ids.length === 0) return;

  const unique = Array.from(new Set(ids));

  const orgMap = {};
  for (const id of unique) {
    try {
      const response = yield call(fetchOrgInfo, id);
      const org = response?.status && response?.organizations?.[0];
      if (org) {
        orgMap[id] = org;
      }
    } catch (_) {
    }
  }

  if (Object.keys(orgMap).length > 0) {
    yield put(upsertOrgs(orgMap));
  }
}
